import $ from "jquery"

function getPublicPaths(_extension) {
	return window?.bbConfig?.publicPaths[_extension] ?? '';
}

const Config = {
	debug: false,
	version: version,
	env: env,
	proxy: "",
	publicPath: "",
	documentRoot: "/",
	module: {
		external: [
			{
				selector: ".bb-iframe-resizer",
				css: [],
				js: [
					{
						url: getPublicPaths('bbIframe') + 'Scripts/iframeResizer.min.js',
						crossDomain: false,
						loadedCallback: () => {
							window.iFrameResize({ log: false, checkOrigin: false })
						},
					},
				],
			},
		],
	},
	map: {
		key: "",
	},
	search_autocomplete_api: {
		dev: "",
		live: "?actionResponse=searchword_autocomplete"
	}
}

export default $.extend(true, Config, window.bbConfig)
